<template>
  <div>
     <CommentEditor
                v-if="esAuditoria"
                field="saludBucal"
                :comentarios="comentarios"
                :odonto="odonto"
    />
    <h5>Indicadores de Salud Bucal (Piezas)</h5>

    <b-row v-for="(fila, filaIndex) in filasIndicadores" :key="filaIndex">
      <b-col cols="4" class="mt-1">
        <b-form-radio-group
          v-model="selecciones[filaIndex].seleccion"
          :options="fila"
          buttons
          button-variant="outline-success"
          size="sm"
          @change="resetIndicadores(filaIndex)"
        />
      </b-col>

      <b-col cols="6" v-if="selecciones[filaIndex].seleccion">
        <b-row>
          <b-col cols="4">
            <b-form-group label="Placa">
              <b-form-select
                :disabled="selecciones[filaIndex].seleccion === '-'"
                v-model="selecciones[filaIndex].placa"
                :options="opcionesNumericas"
                size="sm"
              />
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label="Cálculo">
              <b-form-select
              :disabled="selecciones[filaIndex].seleccion === '-'"
                v-model="selecciones[filaIndex].calculo"
                :options="opcionesNumericas"
                size="sm"
              />
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label="Gingivitis">
              <b-form-select
               :disabled="selecciones[filaIndex].seleccion === '-'"
                v-model="selecciones[filaIndex].gingivitis"
                :options="opcionesNumericasGingivitis"
                size="sm"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <hr />
    <b-row class="mb-1">
      <b-col cols="3">
        <label class="font-weight-bold">Totales:</label>
      </b-col>
      <b-col>
        <label class="text-primary">Placa: {{ promedios.placa }}</label>
      </b-col>
      <b-col>
        <label class="text-primary">Cálculo: {{ promedios.calculo }}</label>
      </b-col>
      <b-col>
        <label class="text-primary">Gingivitis: {{ promedios.gingivitis }}</label>
      </b-col>
    </b-row>

    <hr />
    <b-row class="mb-1">
      <b-col cols="3">
        <label class="font-weight-bold">Enf. periodontal</label>
      </b-col>
      <b-col>
        <b-form-radio-group
          v-model="saludBucal.enfermedadPeriodontal"
          :options="opcionesPeriodontales"
          buttons
          button-variant="outline-danger"
          size="sm"
        />
      </b-col>
    </b-row>

    <b-row class="mb-1">
      <b-col cols="3">
        <label class="font-weight-bold">Mal oclusión</label>
      </b-col>
      <b-col>
        <b-form-radio-group
          v-model="saludBucal.malOclusion"
          :options="opcionesMalaOclusion"
          buttons
          button-variant="outline-danger"
          size="sm"
        />
      </b-col>
    </b-row>

    <b-row class="mb-1">
      <b-col cols="3">
        <label class="font-weight-bold">Fluorosis</label>
      </b-col>
      <b-col>
        <b-form-radio-group
          v-model="saludBucal.fluorosis"
          :options="opcionesPeriodontales"
          buttons
          button-variant="outline-danger"
          size="sm"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>

import CommentEditor from '../../../atencionMedica/components/CommentEditor/CommentEditor.vue';

export default {
  name: 'SaludBucal',

  components: {
    CommentEditor
  },

  data() {
    return {
      odonto:true,
      esAuditoria:false,
      filasIndicadores: [
        ['-', '16', '17', '55'],
        ['-', '11', '21', '51'],
        ['-', '26', '27', '65'],
        ['-', '31', '41', '71'],
        ['-', '36', '37', '75'],
        ['-', '46', '47', '85']
      ],

      selecciones: [
        { seleccion: '16', placa: '-', calculo: '-', gingivitis: '-' },
        { seleccion: '11', placa: '-', calculo: '-', gingivitis: '-' },
        { seleccion: '26', placa: '-', calculo: '-', gingivitis: '-' },
        { seleccion: '31', placa: '-', calculo: '-', gingivitis: '-' },
        { seleccion: '36', placa: '-', calculo: '-', gingivitis: '-' },
        { seleccion: '46', placa: '-', calculo: '-', gingivitis: '-' }
      ],

       yaInicializado: false,

      saludBucal: {
        enfermedadPeriodontal: null,
        malOclusion: null,
        fluorosis: null,
      },

      opcionesNumericas: ['-', 1, 2, 3],
      opcionesNumericasGingivitis: ['-', 1],

      opcionesPeriodontales: [
        { text: 'Ninguna', value: null },
        { text: 'Leve', value: 'leve' },
        { text: 'Moderada', value: 'moderada' },
        { text: 'Severa', value: 'severa' }
      ],

      comentarios:{

      },

      opcionesMalaOclusion: [
        { text: 'Ninguna', value: null },
        { text: 'Angle I', value: 'I' },
        { text: 'Angle II', value: 'II' },
        { text: 'Angle III', value: 'III' }
      ]
    };
  },
    mounted() {
      if(!this.saludBucalRecibida) this.emitirSaludBucal();
},
   props: {
     isAuditoria: {
      type: Boolean,
      default: false,
    },
    saludBucalRecibida: {
      type: Object,
      default: null
    },

  },

  computed: {
    promedios() {
      const totales = {
        placa: 0,
        calculo: 0,
        gingivitis: 0,
        countPlaca: 0,
        countCalculo: 0,
        countGingivitis: 0
      };

      this.selecciones.forEach(item => {
        const p = item.placa !== '-' ? parseFloat(item.placa) : NaN;
        const c = item.calculo !== '-' ? parseFloat(item.calculo) : NaN;
        const g = item.gingivitis !== '-' ? parseFloat(item.gingivitis) : NaN;

        if (!isNaN(p)) {
          totales.placa += p;
          totales.countPlaca++;
        }
        if (!isNaN(c)) {
          totales.calculo += c;
          totales.countCalculo++;
        }
        if (!isNaN(g)) {
          totales.gingivitis += g;
          totales.countGingivitis++;
        }
      });

      return {
        placa: totales.countPlaca
          ? (totales.placa / totales.countPlaca).toFixed(2)
          : '-',
        calculo: totales.countCalculo
          ? (totales.calculo / totales.countCalculo).toFixed(2)
          : '-',
        gingivitis: totales.countGingivitis
          ? (totales.gingivitis / totales.countGingivitis).toFixed(2)
          : '-'
      };
    }
  },

  methods: {
    resetIndicadores(index) {
      this.selecciones[index].placa = '-';
      this.selecciones[index].calculo = '-';
      this.selecciones[index].gingivitis = '-';
    },

    emitirSaludBucal() {
      const datos = {
        selecciones: this.selecciones,
        promedios: this.promedios,
        enfermedadPeriodontal: this.saludBucal.enfermedadPeriodontal,
        malOclusion: this.saludBucal.malOclusion,
        fluorosis: this.saludBucal.fluorosis
      };

      this.$emit('update-salud-bucal', datos);
    }
  },

  watch: {
     isAuditoria: {
      deep:true,
      immediate:true,
      handler(nv){
        if(nv){this.esAuditoria = nv}
        console.log("es auditoria sb", nv)
      }
    },
    selecciones: {
      handler() {
        this.emitirSaludBucal();
      },
      deep: true
    },
    saludBucal: {
      handler() {
        this.emitirSaludBucal();
      },
      deep: true
    },
   saludBucalRecibida: {
    handler(newValue) {
      console.log("recivbida sakud", newValue)
      if (!this.yaInicializado) {
        if (newValue === null || newValue === undefined) {
          this.emitirSaludBucal(); // ✅ Emitir si no hay datos recibidos
          //this.yaInicializado = true;
        } else {
          // ✅ Cargar datos si vienen del padre
          this.saludBucal = {
            enfermedadPeriodontal: newValue.enfermedadPeriodontal || null,
            malOclusion: newValue.malOclusion || null,
            fluorosis: newValue.fluorosis || null
          };

          this.selecciones = newValue.selecciones || this.selecciones;

          console.log("saludBucal recibida", newValue);
          this.yaInicializado = true;
        }
      }
    },
    immediate: true, // ✅ Para que se ejecute al montar si ya vino el prop
    deep: true
  }

  }
};
</script>
